import { loginRoot } from '../config'
import vue from 'vue'

function url (api) {
  return loginRoot + '/'+api
}

// 验证码
export function verification_api (data) {
  // console.log(data)
  return vue.http({
    method: 'post',
    url: url('verification'),
    body:{
      email:data
    }
  })
}

// 获取缓存验证码
export function verifi_api(data) {
  return vue.http({
    method: 'post',
    url: url('verifi'),
    body:{
      email:data
    }
  })
}

// 注册
export function register_api (data) {
  // console.log(data)
  return vue.http({
    method: 'post',
    url: url('register'),
    body:{
      data:data
    }
  })
}

// 登录
export function api_signUp(data) {
  return vue.http({
    isSign:true,
    method: 'post',
    url: url('sign_up'),
    body: data
  });
}
